import {UI} from "../../../../stem-core/src/ui/UIBase";

import {styleRule} from "../../../../stem-core/src/decorators/Style";
import {FormContainerPage} from "./FormContainerPage";
import {GenericSignUpPasswordless, GenericSignUpPasswordlessStyle} from "./GenericSignUpPasswordless";
import {registerStyle, Theme} from "../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../Messages";
import {SocialLoginButtons} from "./SocialLoginButtons";
import {TosMessage} from "../components/TosMessage";
import {isIframe} from "../../../Utils";
import {LineSeparator} from "../../../ui/LineSeparator";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../../blink-sdk/utils/AnalyticsClient";
import {iFrameState} from "../../../services/IFrameState";


export class SignUpPasswordlessClassStyle extends GenericSignUpPasswordlessStyle {
    @styleRule
    headerElement = {
        paddingTop: 24, // Careful when removing this. Check that the modals height is ok.
    };
}

@registerStyle(SignUpPasswordlessClassStyle)
export class SignUpPasswordlessClass extends GenericSignUpPasswordless {
    emailInputEventSent = false;

    getHeaderSection() {
        const {styleSheet} = this;

        return [
            <SocialLoginButtons className={styleSheet.headerElement}
                                onButtonClick={(socialAppData) => this.handleSocialLoginButtonClick(socialAppData)}
                                onLoginCallback={() => this.signUpAction()} />,
            <LineSeparator text={Messages.or} className={styleSheet.headerElement} lineColor={Theme.props.AUTHENTICATION_LINE_COLOR}/>,
        ];
    }

    handleSocialLoginButtonClick({clientName}) {
        dispatchAnalyticsEvent(AnalyticsEventType.SOCIAL_LOGIN_BUTTON_CLICKED, {provider: clientName})
    }

    getFooterSection() {
        return <TosMessage preMessage={Messages.tosPreMessage}/>;
    }

    onEmailInputChange() {
        super.onEmailInputChange();
        if (this.emailInputEventSent) {
            return;
        }
        this.emailInputEventSent = true;
    }

    getSignupRedirectUrl() {
        if (isIframe()) {
            return iFrameState.merchantPageUrl;
        }

        return window.location.origin;
    }
}

export const SignUpPasswordless = FormContainerPage(SignUpPasswordlessClass);
